import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import MainPage from '@/components/MainPage'
import ThankYou from '@/components/ThankYou'
// import MainCRM from "@/components/MainCRM";
const MainCRM = () =>
   import(/* webpackChunkName: "MainCRM" */ '@/components/MainCRM')

/** Building views **/
const BuildingMainPage = () =>
   import(
      /* webpackChunkName: "BuildingMainPage" */
      '@/components/views/BuildingMainPage'
   )
const Login = () =>
   import(
      /* webpackChunkName: "BuildingMainPage" */
      '@/components/views/Login'
   )
const BankKevasMain = () =>
   import(
      /* webpackChunkName: "BankKevasMain" */ '../components/views/bankKevas/buildingScope/bankKevasMain.vue'
   )
const BuildingPage = () =>
   import(/* webpackChunkName: "BuildingPage" */ '@/components/BuildingPage')
const ApartmentsList = () =>
   import(
      /* webpackChunkName: "ApartmentsList" */
      '@/components/views/ApartmentsList'
   )
const FacilitiesAndSystems = () =>
   import(
      /* webpackChunkName: "FacilitiesAndSystems" */
      '@/components/views/FacilitiesAndSystems'
   )

const FacilityPage = () =>
   import(
      /* webpackChunkName: "FacilityPage" */
      '@/components/views/facilitiesAndSystems/FacilityPage.vue'
   )

const AddNewFacilityPage = () =>
   import(
      /* webpackChunkName: "AddNewFacilityPage" */
      '@/components/views/facilitiesAndSystems/AddNewFacilityPage'
   )
const BuildingStructure = () =>
   import(
      /* webpackChunkName: "BuildingStructure" */
      '@/components/views/BuildingStructure'
   )
const PaymentSettings = () =>
   import(
      /* webpackChunkName: "PaymentSettings" */
      '@/components/views/PaymentSettings'
   )

const NotesReport = () =>
   import(
      /* webpackChunkName: "NotesReport" */
      '@/components/views/NotesReport'
   )
const VaadSettings = () =>
   import(
      /* webpackChunkName: "VaadSettings" */
      '@/components/views/VaadSettings'
   )
const BuildingProperties = () =>
   import(
      /* webpackChunkName: "BuildingProperties" */
      '@/components/views/BuildingProperties'
   )
const PaymentsList = () =>
   import(
      /* webpackChunkName: "PaymentsList" */
      '@/components/views/PaymentsList'
   )
const DebtList = () =>
   import(/* webpackChunkName: "DebtList" */ '@/components/views/DebtList')
const KevaList = () =>
   import(
      /* webpackChunkName: "KevaList" */
      '@/components/partials/creditCardReport/KevaList'
   )
const ScheduleTaskView = () =>
   import(
      /* webpackChunkName: "ScheduleTaskView" */
      '@/components/views/ScheduleTaskView'
   )

const Reports = () =>
   import(
      /* webpackChunkName: "Reports" */
      '@/components/views/Reports'
   )
// -----------------------------------------------
// this is OLD expenses section
const ExpensesMain = () =>
   import(
      /* webpackChunkName: "ExpensesMain" */
      '@/components/views/expenses/ExpensesMain'
   )
const ExpensesModal = () =>
   import(
      /* webpackChunkName: "ExpensesModal" */
      '@/components/views/expenses/ExpensesModal'
   )
// -----------------------------------------------
// this is NEW expenses section
const NewExpenses = () =>
   import(
      /* webpackChunkName: "NewExpenses" */
      '@/components/views/expensesNew/ExpensesMainV3'
   )

const AddNewExpenses = () =>
   import(
      /* webpackChunkName: "AddNewExpens" */
      '@/components/views/expensesNew/AddNewExpenses'
   )
const EditExpense = () =>
   import(
      /* webpackChunkName: "EditExpense" */
      '@/components/views/expensesNew/EditExpense'
   )

const ExpensesMainV3 = () =>
   import(
      /* webpackChunkName: "ExpensesMainV3" */
      '@/components/views/expensesNew/ExpensesMainV3'
   )

// ------------------------------------------------
const BalanceReport = () =>
   import(
      /* webpackChunkName: "BalanceReport" */
      '@/components/views/BalanceReport'
   )
const BuildingAccountingReport = () =>
   import(
      /* webpackChunkName: "AccountingReport" */
      '@/components/views/AccountingReport'
   )
const AccountingReport = () =>
   import(
      /* webpackChunkName: "AccountingReport" */
      '@/components/views/AccountingReport'
   )
const IncomeList = () =>
   import(/* webpackChunkName: "IncomeList" */ '@/components/views/IncomeList')

const IncomeListV2 = () =>
   import(
      /* webpackChunkName: "IncomeListV2" */ '@/components/views/IncomeListV2'
   )
const CreditCardPayments = () =>
   import(
      /* webpackChunkName: "CreditCardPayments" */
      '@/components/views/CreditCardPayments'
   )
const CreditCardReport = () =>
   import(
      /* webpackChunkName: "CreditCardReport" */
      '@/components/views/CreditCardReport'
   )
const CreditCardTransferReport = () =>
   import(
      /* webpackChunkName: "CreditCardTransferReport" */
      '@/components/views/CreditCardTransferReport'
   )
const BankKevasTransferReport = () =>
   import(
      /* webpackChunkName: "BankKevasTransferReport" */
      '@/components/views/bankKevas/generalScope/BankKevasTransferReport.vue'
   )
const MessageBoard = () =>
   import(
      /* webpackChunkName: "MessageBoard" */
      '@/components/views/MessageBoard'
   )
const MessagesView = () =>
   import(
      /* webpackChunkName: "MessagesView" */
      '@/components/views/MessagesView'
   )
const GeneralMessagesView = () =>
   import(
      /* webpackChunkName: "GeneralMessagesView" */
      '@/components/views/GeneralMessagesView'
   )
const BankSettingsView = () =>
   import(
      /* webpackChunkName: "BankSettingsView" */
      '@/components/views/BankSettingsView'
   )
const FailedKevaReportView = () =>
   import(
      /* webpackChunkName: "FailedKevaReportView" */
      '@/components/views/FailedKevaReportView'
   )
const ChecksReport = () =>
   import(
      /* webpackChunkName: "ChecksReport" */
      '@/components/views/ChecksReport'
   )

const BuildingMessages = () =>
   import(
      /* webpackChunkName: "BuildingMessages" */
      '@/components/views/messages/BuildingMessages'
   )
const WhatsappMain = () =>
   import(
      /* webpackChunkName: "WhatsappMain" */
      '@/components/views/whatsapp/WhatsappMain'
   )
const SapakimMain = () =>
   import(
      /* webpackChunkName: "SapakimMain" */
      '@/components/views/sapakim/SapakimMain'
   )
const SapakimFilter = () =>
   import(
      /* webpackChunkName: "SapakimFilter" */
      '@/components/views/sapakim/SapakimFilter'
   )
const GeneralMessages = () =>
   import(
      /* webpackChunkName: "GeneralMessages" */
      '@/components/views/messages/GeneralMessages'
   )
const CashReport = () =>
   import(/* webpackChunkName: "CashReport" */ '@/components/views/CashReport')

/** Apartment page views **/
const ApartmentPage = () =>
   import(
      /* webpackChunkName: "ApartmentPage" */
      '@/components/views/ApartmentPage'
   )
const MaintenanceTasksPlan = () =>
   import(
      /* webpackChunkName: "MaintenanceTasksPlan" */ '@/components/views/maintenance-new/MaintenanceTasksPlan'
   )
const MaintenanceMain = () =>
   import(
      /* webpackChunkName: "MaintenanceMain" */ '@/components/views/maintenance-new/MaintenanceMain'
   )
const MaintenanceFullTaskPage = () =>
   import(
      /* webpackChunkName: "MaintenanceMain" */ '@/components/views/maintenance-new/MaintenanceFullTaskPage'
   )
const MalfunctionsView = () =>
   import(
      /* webpackChunkName: "MalfunctionsView" */ '@/components/views/malfunction-new/MalfunctionMain'
   )
const MalfunctionFullPage = () =>
   import(
      /* webpackChunkName: "MalfunctionFullPage" */ '@/components/views/malfunction-new/MalfunctionFullPage'
   )
const addNewMalfunction = () =>
   import(
      /* webpackChunkName: "addNewMalfunction" */ '@/components/views/malfunction-new/addNewMalfunction.vue'
   )
const AWS = () => import(/* webpackChunkName: "AWS" */ '@/components/views/AWS')
const DigitalDepositedChecksReport = () =>
   import(
      /* webpackChunkName: "DigitalDepositedChecksReport" */
      '@/components/views/DigitalDepositedChecksReport'
   )

/** Apartment page views **/
// import ApartmentPage from '@/components/views/ApartmentPage'

/** Company admin views **/
const NewBuilding = () =>
   import(
      /* webpackChunkName: "NewBuilding" */
      '@/components/views/NewBuilding'
   )
const DevicesWebApp = () =>
   import(
      /* webpackChunkName: "Report" */
      '@/components/views/devicesWebApp/DevicesWebApp'
   )
const Stats = () => import(/* webpackChunkName: "Stats" */ '@/components/Stats')

const Dashboard = () =>
   import(/* webpackChunkName: "Dashboard" */ '@/components/Dashboard')
const CompanySettings = () =>
   import(
      /* webpackChunkName: "CompanySettings" */
      '@/components/views/CompanySettings'
   )

const BankAccountsView = () =>
   import(
      /* webpackChunkName: "BankAccountsView" */
      '@/components/views/BankAccountsView'
   )
const MainMaagar = () =>
   import(
      /* webpackChunkName: "MainMaagar" */
      '@/components/views/maagar/MainMaagar'
   )
const MaagarComponent = () =>
   import(
      /* webpackChunkName: "MaagarComponent" */
      '@/components/views/maagar/components/MaagarComponent'
   )

const MobileSettings = () =>
   import(
      /* webpackChunkName: "MobileSettings" */
      '@/components/views/MobileSettings'
   )
const DebtsList = () =>
   import(/* webpackChunkName: "debtslist" */ '@/components/views/DebtsList')
const OverVeshav = () =>
   import(
      /* webpackChunkName: "overveshav" */ '@/components/views/reports/Report'
   )
const BuildingPaymentsReport = () =>
   import(
      /* webpackChunkName: "BuildingPaymentsReport" */ '@/components/views/BuildingPaymentsReport'
   )
const ChecksSearch = () =>
   import(
      /* webpackChunkName: "checkssearch" */ '@/components/views/ChecksSearch'
   )

/** Ghost views**/
import CCdone from '@/components/views/CCdone'
// import Atidi from "@/components/views/Atidi";

const Billings = () =>
   import(/* webpackChunkName: "Billings" */ '@/components/views/Billings')
const LockAlert = () =>
   import(/* webpackChunkName: "LockAlert" */ '@/components/views/LockAlert')
const Atidi = () =>
   import(/* webpackChunkName: "Atidi" */ '@/components/views/Atidi')

import { Event } from '../eventer.js'

Vue.use(Router)
Vue.use(VueResource)

// Global error interception
Vue.http.interceptors.push((request, next) => {
   next(response => {
      if (response.status === 500) {
         alert('שגיאה טכנית')
      }
   })
})

// Global API communications detection
Vue.http.interceptors.push((request, next) => {
   if (request.url.includes('/api/')) {
   }
   next(response => {
      if (response.url.includes('/api/')) {
         // Starting!!
      }
   })
})

export default new Router({
   mode: 'history',
   routes: [
      {
         path: '/',
         name: 'Main',
         component: MainPage,
      },
      {
         path: '/login',
         name: 'Login',
         component: Login,
      },
      {
         path: '/UserIsLocked',
         name: 'LockAlert',
         component: LockAlert,
      },
      {
         path: '/thankYou',
         name: 'ThankYou',
         component: ThankYou,
      },
      {
         path: '/main',
         name: 'MainCRM',
         component: MainCRM,
         children: [
            {
               path: 'construction',
               name: 'Atidi',
               component: Atidi,
            },
            {
               path: 'billing',
               name: 'Billings',
               component: Billings,
            },
            {
               path: 'aws',
               name: 'AWS',
               component: AWS,
            },
            {
               path: 'stats',
               name: 'Stats',
               component: Dashboard,
            },
            {
               path: 'info',
               name: 'MainMaagar',
               component: MainMaagar,
               children: [
                  {
                     path: 'buildings',
                     name: 'MaagarComponent',
                     component: MaagarComponent,
                     props: true,
                  },
               ],
            },
            {
               path: 'checks-search',
               name: 'ChecksSearch',
               component: ChecksSearch,
            },
            {
               path: 'buildings-list',
               name: 'BuildingsList',
               component: Stats,
            },
            {
               path: 'debts-list',
               name: 'DebtsList',
               component: DebtsList,
            },
            {
               path: 'schedule-tasks',
               name: 'ScheduleTaskView',
               component: ScheduleTaskView,
            },
            {
               path: 'failed-keva',
               name: 'FailedKevaReportView',
               component: FailedKevaReportView,
            },
            {
               path: 'DigitalDepositedChecksReport',
               name: 'DigitalDepositedChecksReport',
               component: DigitalDepositedChecksReport,
            },
            {
               path: 'settings',
               name: 'CompanySettings',
               component: CompanySettings,
            },
            {
               path: 'new-building',
               name: 'NewBuilding',
               component: NewBuilding,
            },
            {
               path: 'bank-accounts',
               name: 'BankAccountsView',
               component: BankAccountsView,
            },
            {
               path: 'mobileSettings',
               name: 'MobileSettings',
               component: MobileSettings,
            },
            {
               name: 'GeneralMessagesView',
               path: 'general-messages-view',
               component: GeneralMessagesView,
            },
            ,
            {
               path: 'general-messages',
               name: 'GeneralMessages',
               component: GeneralMessages,
            },
            {
               name: 'MalfunctionsView',
               path: 'MalfunctionsView',
               component: MalfunctionsView,
            },
            {
               name: 'addNewMalfunction',
               path: 'add-new-malfunction',
               component: addNewMalfunction,
            },
            {
               name: 'GlobalMaintenanceMain',
               path: 'global-maintenance-main',
               component: MaintenanceMain,
            },
            {
               name: 'GlobalFacilitiesAndSystems',
               path: 'GlobalFacilitiesAndSystems',
               component: FacilitiesAndSystems,
            },
            {
               name: 'GlobalAddNewFacilityPage',
               path: 'GlobalAddNewFacilityPage',
               component: AddNewFacilityPage,
            },
            {
               name: 'CreditCardTransferReport',
               path: 'credit-card-transfer-report',
               component: CreditCardTransferReport,
            },
            {
               name: 'BankKevasTransferReport',
               path: 'bank-kevas-transfer-report',
               component: BankKevasTransferReport,
            },
            {
               name: 'WhatsappMain',
               path: 'whatsappMain',
               component: WhatsappMain,
            },
            {
               name: 'SapakimMain',
               path: 'sapakimMain',
               component: SapakimMain,
            },
            {
               name: 'Reports',
               path: 'reports/:buildingId?',
               component: Reports,
            },
            {
               name: 'AccountingReport',
               path: 'accounting-report',
               component: AccountingReport,
            },
            {
               name: 'SapakimFilter',
               path: 'sapakimFilter',
               component: SapakimFilter,
            },
            {
               path: 'building/:id',
               name: 'Building',
               component: BuildingPage,

               children: [
                  {
                     name: 'OverVeshav',
                     path: 'over-veshav',
                     component: OverVeshav,
                  },
                  {
                     name: 'BuildingPaymentsReport',
                     path: 'BuildingPaymentsReport',
                     component: BuildingPaymentsReport,
                  },
                  {
                     name: 'BuildingMainPage',
                     path: 'main',
                     component: BuildingMainPage,
                  },
                  {
                     path: 'BuildingStructure',
                     name: 'BuildingStructure',
                     component: BuildingStructure,
                     props: true,
                  },
                  {
                     name: 'FacilitiesAndSystems',
                     path: 'FacilitiesAndSystems',
                     component: FacilitiesAndSystems,
                  },
                  {
                     name: 'MaintenanceMain',
                     path: 'maintenance-main',
                     component: MaintenanceMain,
                  },
                  {
                     name: 'MaintenanceFullTaskPage',
                     path: 'maintenance-full-task-page/:taskNumber',
                     component: MaintenanceFullTaskPage,
                  },
                  {
                     name: 'MaintenanceTasksPlan',
                     path: 'MaintenanceTasksPlan',
                     component: MaintenanceTasksPlan,
                  },
                  {
                     name: 'MalfunctionFullPage',
                     path: 'malfunction-full-page/:taskNumber',
                     component: MalfunctionFullPage,
                  },
                  {
                     name: 'MalfunctionsBuildingView',
                     path: 'building-malfunctions',
                     component: MalfunctionsView,
                  },
                  {
                     name: 'addNewMalfunctionInBuilding',
                     path: 'add-new-malfunction-in-building',
                     component: addNewMalfunction,
                  },
                  {
                     name: 'SapakimMainForBuilding',
                     path: 'SapakimMain',
                     component: SapakimMain,
                  },
                  {
                     name: 'BankSettings',
                     path: 'bank-account',
                     component: BankSettingsView,
                  },
                  {
                     name: 'ApartmentsList',
                     path: 'apartments',
                     component: ApartmentsList,
                  },
                  {
                     name: 'MessageBoard',
                     path: 'messageBoard',
                     component: MessageBoard,
                  },
                  {
                     name: 'VaadSettings',
                     path: 'vaad',
                     component: VaadSettings,
                  },
                  {
                     name: 'BuildingProperties',
                     path: 'properties',
                     component: BuildingProperties,
                  },
                  {
                     name: 'PaymentSettings',
                     path: 'payment-settings',
                     component: PaymentSettings,
                  },
                  {
                     name: 'MessagesView',
                     path: 'messages-view',
                     component: MessagesView,
                  },
                  {
                     name: 'PaymentsList',
                     path: 'payments-list',
                     component: PaymentsList,
                  },
                  {
                     name: 'NotesReport',
                     path: 'NotesReport',
                     component: NotesReport,
                  },
                  {
                     name: 'CreditCardPayments',
                     path: 'credit-card-payments',
                     component: CreditCardPayments,
                  },
                  {
                     name: 'CreditCardReport',
                     path: 'credit-card-report',
                     component: CreditCardReport,
                  },
                  {
                     name: 'CashReport',
                     path: 'CashReport',
                     component: CashReport,
                  },
                  {
                     name: 'BankKevasMain',
                     path: 'BankKevasMain',
                     component: BankKevasMain,
                  },
                  {
                     name: 'ChecksReport',
                     path: 'checks-report',
                     component: ChecksReport,
                  },
                  {
                     name: 'Reports',
                     path: 'reports',
                     component: Reports,
                  },
                  //this is NEW expenses
                  {
                     name: 'ExpensesMainV3',
                     path: 'ExpensesMainV3',
                     component: NewExpenses,
                  },

                  {
                     name: 'AddNewExpenses',
                     path: 'AddNewExpenses',
                     component: AddNewExpenses,
                  },

                  {
                     name: 'EditExpense',
                     path: 'EditExpense/:expenseId',
                     component: EditExpense,
                  },

                  {
                     name: 'ExpensesMainV3',
                     path: 'ExpensesMainV3',
                     component: ExpensesMainV3,
                  },

                  // ---------------------------------
                  //---------------------------------
                  //this is OLD expenses
                  {
                     name: 'ExpensesMain',
                     path: 'expensesMain',
                     component: ExpensesMain,
                  },
                  {
                     name: 'ExpensesModal',
                     path: 'expenses-modal',
                     component: ExpensesModal,
                  },
                  //---------------------------------
                  {
                     name: 'IncomeList',
                     path: 'income-list',
                     component: IncomeList,
                  },
                  {
                     name: 'IncomeListV2',
                     path: 'income-listV2',
                     component: IncomeListV2,
                  },
                  {
                     name: 'BalanceReport',
                     path: 'balance-report',
                     component: BalanceReport,
                  },
                  {
                     name: 'BuildingAccountingReport',
                     path: 'accounting-report',
                     component: AccountingReport,
                  },
                  {
                     name: 'DebtList',
                     path: 'debt-list',
                     component: DebtList,
                  },
                  {
                     name: 'KevaList',
                     path: 'keva-list',
                     component: KevaList,
                  },
                  {
                     name: 'ApartmentPage',
                     path: 'apartment/:apartment',
                     component: ApartmentPage,
                     props: true,
                  },
                  {
                     name: 'AddNewFacilityPage',
                     path: 'AddNewFacilityPage',
                     component: AddNewFacilityPage,
                  },
                  {
                     name: 'FacilityPage',
                     path: 'facility/:facilityId',
                     component: FacilityPage,
                  },
                  {
                     name: 'DevicesWebApp',
                     path: 'devicesWebApp',
                     component: DevicesWebApp,
                  },
                  {
                     name: 'BuildingMessages',
                     path: 'buildingMessages',
                     component: BuildingMessages,
                  },
               ],
            },
         ],
      },
      {
         path: 'CCdone',
         name: 'CCdone',
         component: CCdone,
      },
   ],
   //    },
   // ],
})



// WEBPACK FOOTER //
// ./src/router/index.js